import {queryOptions} from '@tanstack/react-query';
import EndPoints from './endpoints';
import axios from './axios';
import client from './client';

const queries = {
  meta: queryOptions({
    queryKey: ['meta'],
    queryFn: () => axios.get<MetaData>(EndPoints.META),
  }),
  visitors: (id?: string) =>
    queryOptions({
      queryKey: ['visitors' + id],
      queryFn: () => axios.get<Visitor[]>(EndPoints.VISITORS(id!)),
      enabled: !!id,
    }),
  visaRequest: (id?: string) =>
    queryOptions({
      queryKey: ['visa_request' + id],
      queryFn: () => axios.get<VisaRequest>(EndPoints.VISA_REQUEST(id!)),
      enabled: !!id,
    }),
  visitor(id: string) {
    return client.getQueryData(this.visitors(id).queryKey)![0];
  },
  request(id: string) {
    return client.getQueryData(this.visaRequest(id).queryKey)!;
  },
  start(token?: string) {
    return axios.get<{id?: string}>(EndPoints.APPLICATION_TOKEN(token!));
  },
};

export default queries;
